import React from 'react';

export interface ActiveCallProps {
  remote: string;
  muted: boolean;
  held: boolean;
  answeredAt: number;
  onMute: (muted: boolean) => void;
  onHold: (hold: boolean) => void;
  onHangup: () => void;
  onDtmf: (digit: string) => void;
  /** F4.2-A4: opens the transfer panel. Optional for back-compat with test fixtures predating F4.2. */
  onOpenTransfer?: () => void;
}

const DIGITS = ['1','2','3','4','5','6','7','8','9','*','0','#'];

export function ActiveCall(props: ActiveCallProps): React.JSX.Element {
  return (
    <section>
      <strong>En llamada</strong>
      <div>{props.remote}</div>
      <div>
        <button type="button" onClick={() => props.onMute(!props.muted)}>{props.muted ? 'Unmute' : 'Mute'}</button>
        <button type="button" onClick={() => props.onHold(!props.held)}>{props.held ? 'Resume' : 'Hold'}</button>
        {props.onOpenTransfer ? (
          <button type="button" onClick={props.onOpenTransfer}>Transferir</button>
        ) : null}
        <button type="button" onClick={props.onHangup}>Colgar</button>
      </div>
      <div>
        {DIGITS.map((d) => (
          <button key={d} type="button" onClick={() => props.onDtmf(d)}>{d}</button>
        ))}
      </div>
    </section>
  );
}
